import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-decision-modal',
  templateUrl: './decision-modal.component.html',
  styleUrls: ['./decision-modal.component.scss']
})
export class DecisionModalComponent implements OnInit {
  public header = '';
  public resultSubject: Subject<boolean> = new Subject();
  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<DecisionModalComponent>,
  ) {
    this.header = data.header;
    this.resultSubject = data.resultSubject;
  }

  ngOnInit() {

  }

  ok() {
    this.resultSubject.next(true);
    this.dialogRef.close();
  }

  cancel() {
    this.resultSubject.next(false);
    this.dialogRef.close();
  }
}
